import {Rectangle, Sprite, type Application} from 'pixi.js';

/** Independent GPU snapshot: atlas repacking cannot erase the last good map. */
export class WarpFrame {
  private sprite: Sprite | null = null;

  preserve(app: Application): void {
    if (this.sprite) return;
    const screen = app.renderer.screen;
    const texture = app.renderer.generateTexture({
      target: app.stage,
      frame: new Rectangle(0, 0, screen.width, screen.height),
      resolution: 1,
      clearColor: '#000000',
    });
    this.sprite = new Sprite(texture);
    this.sprite.label = 'warp-last-good-map';
    this.sprite.eventMode = 'none';
    app.stage.addChild(this.sprite);
  }

  resize(app: Application): void {
    if (!this.sprite) return;
    this.sprite.width = app.renderer.screen.width;
    this.sprite.height = app.renderer.screen.height;
  }

  release(): void {
    if (!this.sprite) return;
    this.sprite.removeFromParent();
    this.sprite.destroy({texture: true, textureSource: true});
    this.sprite = null;
  }
}
